import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addProviderAccountPaymentMethodTypeSetupRequest = {};
var _addProviderAccountPaymentMethodTypeSetupResponse = {};
var _claimProviderAccountOAuthRequest = {};
var _claimProviderAccountOAuthResponse = {};
var _connectProviderAccountDirectlyRequest = {};
var _connectProviderAccountDirectlyResponse = {};
var _connectProviderAccountOAuthRequest = {};
var _connectProviderAccountOAuthResponse = {};
var _connectProviderAccountRequest = {};
var _connectProviderAccountResponse = {};
var _createProviderAccountOAuthRequest = {};
var _createProviderAccountOAuthResponse = {};
var _disconnectProviderAccountRequest = {};
var _disconnectProviderAccountResponse = {};
var _enableRecurringPaymentsRequest = {};
var _enableRecurringPaymentsResponse = {};
var _getProviderAccountRequest = {};
var _getProviderAccountResponse = {};
var _listProviderAccountsRequest = {};
var _listProviderAccountsResponse = {};
var _listProviderConnectionsRequest = {};
var _listProviderConnectionsResponse = {};
var _reconnectProviderAccountDirectlyRequest = {};
var _reconnectProviderAccountDirectlyResponse = {};
var _reconnectProviderAccountOAuthRequest = {};
var _reconnectProviderAccountOAuthResponse = {};
var _reconnectProviderAccountRequest = {};
var _reconnectProviderAccountResponse = {};
var _removeProviderAccountPaymentMethodTypeSetupRequest = {};
var _removeProviderAccountPaymentMethodTypeSetupResponse = {};
var _updateProviderAccountPaymentMethodTypeSetupRequest = {};
var _updateProviderAccountPaymentMethodTypeSetupResponse = {};
var _updateProviderAccountRequest = {};
var _updateProviderAccountResponse = {};
function resolveWixCashierV2SettingsProviderAccountsServiceV2Url(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/payment-settings-web',
                destPath: '/api',
            },
            {
                srcPath: '/ambassador/payment-settings-web',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/payment-settings-web',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/payment-settings-web',
                destPath: '/api',
            },
            {
                srcPath: '/ambassador/payment-settings-web',
                destPath: '',
            },
            {
                srcPath: '/cashier/v2/settings',
                destPath: '/v2/settings',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/cashier/v2/settings',
                destPath: '/v2/settings',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/payment-settings-web',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/payment-settings-web',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/payment-settings-web',
                destPath: '',
            },
        ],
        'cronulla-jobs._base_domain_': [
            {
                srcPath: '/cashier/payment-settings-web/jobs',
                destPath: '/internal-api/jobs',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/ambassador/payment-settings-web',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/ambassador/payment-settings-web',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/ambassador/payment-settings-web',
                destPath: '',
            },
        ],
        'currency-converter.wixapps.net': [
            {
                srcPath: '/_api/payment-settings-web',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * List of provider accounts, connected by the merchant.
 *
 * Returns list of provider accounts entities.
 */
export function listProviderAccounts(payload) {
    var _a = serializer(_listProviderAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listProviderAccountsResponse, {}).fromJSON;
    function __listProviderAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'GET',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ListProviderAccounts',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listProviderAccounts.fromReq = fromReq;
    __listProviderAccounts.__isAmbassador = true;
    return __listProviderAccounts;
}
/**
 * Connect providers account.
 *
 * Returns connected provider account entity in case account was connected, or next action to preform in connection flow.
 */
export function connectProviderAccount(payload) {
    var _a = serializer(_connectProviderAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_connectProviderAccountResponse, {}).fromJSON;
    function __connectProviderAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ConnectProviderAccount',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/connect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __connectProviderAccount.fromReq = fromReq;
    __connectProviderAccount.__isAmbassador = true;
    return __connectProviderAccount;
}
/**
 * Deprecated. Use ConnectProviderAccount instead.
 *
 * Connect providers account directly.
 *
 * Returns connected provider account entity.
 * @deprecated It has been replaced with wix.cashier.v2.settings.ConnectProviderAccount(), and will be removed on 2024-02-22.
 */
export function connectProviderAccountDirectly(payload) {
    var _a = serializer(_connectProviderAccountDirectlyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_connectProviderAccountDirectlyResponse, {}).fromJSON;
    function __connectProviderAccountDirectly(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ConnectProviderAccountDirectly',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/direct-connect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __connectProviderAccountDirectly.fromReq = fromReq;
    __connectProviderAccountDirectly.__isAmbassador = true;
    return __connectProviderAccountDirectly;
}
/**
 * Deprecated. Use ConnectProviderAccount instead.
 *
 * Initiate provider account connect via OAuth.
 *
 * Returns OAuth URL prepared for redirect.
 * @deprecated It has been replaced with wix.cashier.v2.settings.ConnectProviderAccount(), and will be removed on 2024-02-22.
 */
export function connectProviderAccountOAuth(payload) {
    var _a = serializer(_connectProviderAccountOAuthRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_connectProviderAccountOAuthResponse, {}).fromJSON;
    function __connectProviderAccountOAuth(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ConnectProviderAccountOAuth',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/oauth-connect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __connectProviderAccountOAuth.fromReq = fromReq;
    __connectProviderAccountOAuth.__isAmbassador = true;
    return __connectProviderAccountOAuth;
}
/**
 * Initiate provider account creation on the provider's side via OAuth.
 *
 * Returns OAuth URL prepared for redirect.
 */
export function createProviderAccountOAuth(payload) {
    var _a = serializer(_createProviderAccountOAuthRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createProviderAccountOAuthResponse, {}).fromJSON;
    function __createProviderAccountOAuth(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.CreateProviderAccountOAuth',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/oauth-create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createProviderAccountOAuth.fromReq = fromReq;
    __createProviderAccountOAuth.__isAmbassador = true;
    return __createProviderAccountOAuth;
}
/**
 * Initiate provider account claim on the provider's side via OAuth.
 *
 * Returns OAuth URL prepared for redirect.
 */
export function claimProviderAccountOAuth(payload) {
    var _a = serializer(_claimProviderAccountOAuthRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_claimProviderAccountOAuthResponse, {}).fromJSON;
    function __claimProviderAccountOAuth(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ClaimProviderAccountOAuth',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/oauth-claim',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __claimProviderAccountOAuth.fromReq = fromReq;
    __claimProviderAccountOAuth.__isAmbassador = true;
    return __claimProviderAccountOAuth;
}
/**
 * Get provider account by its Id.
 *
 * Returns provider account entity.
 */
export function getProviderAccount(payload) {
    var _a = serializer(_getProviderAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getProviderAccountResponse, {}).fromJSON;
    function __getProviderAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'GET',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.GetProviderAccount',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getProviderAccount.fromReq = fromReq;
    __getProviderAccount.__isAmbassador = true;
    return __getProviderAccount;
}
/** List connections for the given provider account. */
export function listProviderConnections(payload) {
    var _a = serializer(_listProviderConnectionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listProviderConnectionsResponse, {}).fromJSON;
    function __listProviderConnections(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'GET',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ListProviderConnections',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/connections',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listProviderConnections.fromReq = fromReq;
    __listProviderConnections.__isAmbassador = true;
    return __listProviderConnections;
}
/**
 * Update provider account by its Id.
 *
 * Returns updated provider account entity.
 */
export function updateProviderAccount(payload) {
    var _a = serializer(_updateProviderAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProviderAccountResponse, {}).fromJSON;
    function __updateProviderAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'PATCH',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.UpdateProviderAccount',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccount.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProviderAccount.fromReq = fromReq;
    __updateProviderAccount.__isAmbassador = true;
    return __updateProviderAccount;
}
/** Disconnect provider account by its Id. */
export function disconnectProviderAccount(payload) {
    var _a = serializer(_disconnectProviderAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disconnectProviderAccountResponse, {}).fromJSON;
    function __disconnectProviderAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'DELETE',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.DisconnectProviderAccount',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disconnectProviderAccount.fromReq = fromReq;
    __disconnectProviderAccount.__isAmbassador = true;
    return __disconnectProviderAccount;
}
/**
 * Reconnect provider's account.
 *
 * Returns reconnected provider account entity in case of direct connection
 * Returns redirect_uri in case of redirect connection
 * Returns both provider account entity and redirect_uri in case of paypal
 */
export function reconnectProviderAccount(payload) {
    var _a = serializer(_reconnectProviderAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reconnectProviderAccountResponse, {}).fromJSON;
    function __reconnectProviderAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'PUT',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ReconnectProviderAccount',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/reconnect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reconnectProviderAccount.fromReq = fromReq;
    __reconnectProviderAccount.__isAmbassador = true;
    return __reconnectProviderAccount;
}
/**
 * Deprecated. Use ReconnectProviderAccount instead.
 *
 * Reconnect provider's account directly.
 *
 * Returns reconnected provider account entity.
 * @deprecated It has been replaced with wix.cashier.v2.settings.ReconnectProviderAccount(), and will be removed on 2024-02-22.
 */
export function reconnectProviderAccountDirectly(payload) {
    var _a = serializer(_reconnectProviderAccountDirectlyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reconnectProviderAccountDirectlyResponse, {}).fromJSON;
    function __reconnectProviderAccountDirectly(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'PUT',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ReconnectProviderAccountDirectly',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/direct-reconnect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reconnectProviderAccountDirectly.fromReq = fromReq;
    __reconnectProviderAccountDirectly.__isAmbassador = true;
    return __reconnectProviderAccountDirectly;
}
/**
 * Deprecated. Use ReconnectProviderAccount instead.
 *
 * Initiate provider account reconnect via OAuth.
 *
 * Returns OAuth URL prepared for redirect.
 * @deprecated It has been replaced with wix.cashier.v2.settings.ReconnectProviderAccount(), and will be removed on 2024-02-22.
 */
export function reconnectProviderAccountOAuth(payload) {
    var _a = serializer(_reconnectProviderAccountOAuthRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reconnectProviderAccountOAuthResponse, {}).fromJSON;
    function __reconnectProviderAccountOAuth(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.ReconnectProviderAccountOAuth',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/oauth-reconnect',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reconnectProviderAccountOAuth.fromReq = fromReq;
    __reconnectProviderAccountOAuth.__isAmbassador = true;
    return __reconnectProviderAccountOAuth;
}
/**
 * Add payment method within the provider's account to enable it at checkout.
 *
 * Returns provider account entity with created payment method.
 */
export function addProviderAccountPaymentMethodTypeSetup(payload) {
    var _a = serializer(_addProviderAccountPaymentMethodTypeSetupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addProviderAccountPaymentMethodTypeSetupResponse, {}).fromJSON;
    function __addProviderAccountPaymentMethodTypeSetup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.AddProviderAccountPaymentMethodTypeSetup',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/payment-method-type-setup',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addProviderAccountPaymentMethodTypeSetup.fromReq = fromReq;
    __addProviderAccountPaymentMethodTypeSetup.__isAmbassador = true;
    return __addProviderAccountPaymentMethodTypeSetup;
}
/**
 * Update payment method within the provider's account.
 *
 * Returns provider account entity with updated payment method.
 */
export function updateProviderAccountPaymentMethodTypeSetup(payload) {
    var _a = serializer(_updateProviderAccountPaymentMethodTypeSetupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateProviderAccountPaymentMethodTypeSetupResponse, {}).fromJSON;
    function __updateProviderAccountPaymentMethodTypeSetup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'PATCH',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.UpdateProviderAccountPaymentMethodTypeSetup',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/payment-method-type-setup/{paymentMethodTypeSetup.paymentMethodTypeId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateProviderAccountPaymentMethodTypeSetup.fromReq = fromReq;
    __updateProviderAccountPaymentMethodTypeSetup.__isAmbassador = true;
    return __updateProviderAccountPaymentMethodTypeSetup;
}
/**
 * Delete payment method within the provider's account.
 *
 * Returns provider account entity.
 */
export function removeProviderAccountPaymentMethodTypeSetup(payload) {
    var _a = serializer(_removeProviderAccountPaymentMethodTypeSetupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeProviderAccountPaymentMethodTypeSetupResponse, {}).fromJSON;
    function __removeProviderAccountPaymentMethodTypeSetup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'DELETE',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.RemoveProviderAccountPaymentMethodTypeSetup',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/payment-method-type-setup/{paymentMethodTypeId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeProviderAccountPaymentMethodTypeSetup.fromReq = fromReq;
    __removeProviderAccountPaymentMethodTypeSetup.__isAmbassador = true;
    return __removeProviderAccountPaymentMethodTypeSetup;
}
/**
 * Request recurring payments for specific provider account.
 *
 * Returns provider account entity with updated recurringOptions for requested provider account
 */
export function enableRecurringPayments(payload) {
    var _a = serializer(_enableRecurringPaymentsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_enableRecurringPaymentsResponse, {}).fromJSON;
    function __enableRecurringPayments(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.cashier.settings.v2.provider_account',
            method: 'POST',
            methodFqn: 'wix.cashier.v2.settings.ProviderAccountsServiceV2.EnableRecurringPayments',
            url: resolveWixCashierV2SettingsProviderAccountsServiceV2Url({
                protoPath: '/v2/settings/provider-accounts/{providerAccountId}/enable-recurring-payments',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __enableRecurringPayments.fromReq = fromReq;
    __enableRecurringPayments.__isAmbassador = true;
    return __enableRecurringPayments;
}
//# sourceMappingURL=http.impl.js.map